/**
 * A deterministic pseudo-random generator seeded by a string (e.g. a collection
 * id). Returns a function that yields the next value in [0, 1) — the same seed
 * always produces the same sequence, so a collection's "randomized" layout is
 * stable across renders.
 *
 * String → 32-bit seed via a small xfnv1a hash, then mulberry32 for the stream.
 */
export function seededRandom(seed: string): () => number {
  // xfnv1a hash → 32-bit unsigned seed.
  let h = 2166136261 >>> 0;
  for (let i = 0; i < seed.length; i++) {
    h = Math.imul(h ^ seed.charCodeAt(i), 16777619);
  }
  let state = h >>> 0;

  // mulberry32 PRNG.
  return function next(): number {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
